import $ from 'jquery';

export const submitForm = (formSelector, data) => {
    const form = $(formSelector);
    const url = form.prop('action');
    return $.ajax({
        url: url,
        dataType: "json",
        type: 'POST',
        data: JSON.stringify(data)
    });

}

export const get = (url) => {
    return $.get(url);
}

export const submitInterestForm = (data) => {
    const url = "api/ajax-inquiring.php";
    return $.ajax({
        url: url,
        dataType: "json",
        type: 'POST',
        data: JSON.stringify(data)
    });
}
export const submitRegisterForm = (data) => {
    const url = "api/ajax-registration.php";
    return $.ajax({
        url: url,
        dataType: "json",
        type: 'POST',
        data: JSON.stringify(data)
    });
}